import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

import { propertyData } from '../data/data'
import { useHooks } from '../utils/getHooks';
import { searchSpace } from '../services/ApiServices';
import processor from '../assets/css/plugins/ajax-loader.gif';

interface Property {
    id: number;
    image: string[];
    tag: string[];
    tag2: string;
    type: string;
    name: string;
    loction: string;
    size: string;
    beds: string;
    sqft: string;
    value: string;
}

export default function SellPropertyOne({ border }: { border: any }) {
    const hooks = useHooks();
    // const spaceList: any[] = hooks.getSpaceList
    // console.log("spaceList", spaceList);

    const [spaceList, setSpaceList] = useState<any[]>([]);
    const [isProcessing, setProcessing] = useState<boolean>(false);

    const formatNumber = (value: string) => {
        return parseFloat(value).toString();
    };

    const searchSpaceAPICall = () => {
        // e.preventDefault()
        setProcessing(true);
        const data = new FormData();

        searchSpace(data).then((res) => {
            console.log("get search space response", res);

            if (res?.status === "success") {
                setSpaceList(res?.data)
                setProcessing(false);
            } else if (res?.status === "error") {
                setSpaceList(res?.data)
                setProcessing(false);
            } else {
                setProcessing(false);
                console.log("search space error", res);
            }
        })
    }

    const amountFormatter = (amount: any) => {
        const formattedAmount = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
            maximumFractionDigits: 2,
        }).format(amount);
        console.log("formattedAmount", formattedAmount);
        return formattedAmount;

        // return <h3 className="prt-price-fix text-primary mt-2">${formattedAmount}</h3>;
    };

    useEffect(() => {
        searchSpaceAPICall();
    }, [])
    return (
        <div className="row list-layout">
            {spaceList.length === 0 && isProcessing ?
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 " style={{}}>
                    <div className="fw-bold ms-1 my-0 text-center mt-3" style={{ color: "#AFABAB" }}><img src={processor} width={'10%'} height={'10%'} /></div>
                </div> :
                spaceList.slice(0, 4).map((item: any, index: number) => {

                    var price: any;
                    var sfPrice: any;
                    if (item?.price) {
                        if (item?.square_feet > 0) {
                            price = `${amountFormatter(item.square_feet)} SF`
                            // price = <AmountFormatter amount={item.square_feet} />
                        }
                    } else {
                        if (item?.square_feet) {
                            price = `${amountFormatter(item.square_feet)} SF`
                        }
                        if (item?.price_per_square) {
                            sfPrice = `${amountFormatter(item.price_per_square)} PSF`
                        } else {
                            sfPrice = `$${amountFormatter(item.monthly_rent)} Mth`
                        }
                    }
                    console.log("price", price);

                    return (
                        <div className="col-xl-6 col-lg-6 col-md-12" key={index}>
                            <div className={`property-listing property-1 bg-white p-2 rounded ${border ? 'border' : 'border-0'}`}>
                                <div className="listing-img-wrapper">
                                    <Link to={"#"}>
                                        <img src={item?.image} className="img-fluid mx-auto rounded" alt="" key={index} />
                                        {/* {item.image.slice(0, 1).map((el, index) => {
                                        return (
                                            <img src={el} className="img-fluid mx-auto rounded" alt="" key={index} />
                                        )
                                    })} */}
                                    </Link>
                                </div>
                                <div className="listing-content">
                                    <div className="listing-detail-wrapper-box">
                                        <div className="listing-detail-wrapper d-flex align-items-center justify-content-between">
                                            <div className="listing-short-detail">
                                                <span className="label bg-light-danger text-danger d-inline-flex mb-1">{item.monthly_rent ? "For Lease" : "For Sale"}</span>
                                                <h4 className="listing-name mb-1 mt-2"><Link to={`/single-property-2/${item.id}`}>{item.value}</Link></h4>
                                                {/* <div className="fr-can-rating">
                                                <i className="fas fa-star fs-xs filled" style={{ margin: '0 2px' }}></i>
                                                <i className="fas fa-star fs-xs filled" style={{ margin: '0 2px' }}></i>
                                                <i className="fas fa-star fs-xs filled" style={{ margin: '0 2px' }}></i>
                                                <i className="fas fa-star fs-xs filled" style={{ margin: '0 2px' }}></i>
                                                <i className="fas fa-star fs-xs" style={{ margin: '0 2px' }}></i>
                                                <span className="reviews_text fs-sm text-muted ms-2">(42 Reviews)</span>
                                            </div> */}
                                            </div>
                                            <div className="list-price">
                                                <h6 className="listing-card-info-price text-primary">{item.value}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="price-features-wrapper">
                                        <div className="list-fx-features d-flex align-items-center justify-content-between mt-3 mb-1">
                                            <div className="listing-card d-flex align-items-center">
                                                <div className="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i className="fa-solid fa-building-shield fs-xs"></i></div><span className="text-muted-2 fs-sm">{item.property_type}</span>
                                            </div>
                                            <div className="listing-card d-flex align-items-center">
                                                <div className="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i className="fa-solid fa-bed fs-xs"></i></div><span className="text-muted-2 fs-sm">{price}</span>
                                            </div>
                                            <div className="listing-card d-flex align-items-center">
                                                {/* {sfPrice && <AmountFormatter amount={sfPrice} />} */}
                                                {sfPrice && <><div className="square--30 text-muted-2 fs-sm circle gray-simple me-2"><i className="fa-solid fa-clone fs-sm"></i></div><span className="text-muted-2">{sfPrice}</span></>}
                                                {item?.price && <><div className="square--30 text-muted-2 fs-sm circle gray-simple me-2"><i className="fa-solid fa-clone fs-sm"></i></div><span className="text-muted-2">{`$${amountFormatter(item.price)}`}</span></>}
                                                {/* <div className="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i className="fa-solid fa-clone fs-xs"></i></div><span className="text-muted-2 fs-sm">{sfPrice ? sfPrice : `$${item.price}`}</span> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="listing-footer-wrapper">
                                        <div className="listing-locate">
                                            <span className="listing-location text-muted-2"><i className="fa-solid fa-location-pin me-1"></i>{item.address}</span>
                                        </div>
                                        <div className="listing-detail-btn">
                                            <Link to={`/property-details/${item?.id}`} className="btn btn-sm px-4 fw-medium btn-primary" onClick={() => sessionStorage.setItem("scrollToFeatured", "true")}>View</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
        </div >
    )
}
